import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import {UtilProvider} from "../../providers/util/util";

/**
 * Generated class for the EssenceMaterialComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'essence-material',
  templateUrl: 'essence-material.html'
})
export class EssenceMaterialComponent implements OnChanges{

  @Input() material;
  @Input() materials;
  @Input() is_choosed:boolean;
  @Input() is_preview:boolean;
  @Input() loading_id;
  @Input() play_id;
  @Output() playMedia = new EventEmitter();
  @Output() onChange = new EventEmitter();


  constructor(public util:UtilProvider) {

  }

  ngOnChanges(changes:SimpleChanges){
    // if(this.material && this.material.duration ){
    //     this.material.duration_str = this.durationString();
    // }
  }

  changeSize(e){
    if(e.path[0].naturalHeight > e.path[0].naturalWidth){
      e.path[0].classList.add('height-img');
    }
  }

  playThisMedia(e){
    e.stopPropagation();
    this.playMedia.emit(1);
  }

  changeChoosed(e){
    this.onChange.emit(e);
  }

  toPreview(){
    if(this.util.canPreview(this.material.title)){
      this.util.previewFile(this.material.source_url);
    }
  }

  openLink(){
    window.open(this.material.source_url,'_blank')
  }

  durationString():number{
    return Math.ceil(this.material.duration/1000);
  }

  Options : any = [];
  SelAll : boolean = false;
  SelectedOptions : any = [];

  SelectAll(){
    if(this.SelAll == true){
      for(var i = 0; i < this.Options.length; i++){
        this.Options[i]['selected'] = true;
      }
    }
    if(this.SelAll == false){
      for(var j = 0; j< this.Options.length; j++){
        this.Options[j]['selected'] = false;
      }
    }
  }

  // dismiss() {
  //   this.viewCtrl.dismiss(this.SelectedOptions);
  // }
  //
  // SelectAndDismiss() {
  //   this.SelectedOptions = this.Options.filter(x => x.selected == true);
  //   this.viewCtrl.dismiss(this.SelectedOptions);
  // }
}



// WEBPACK FOOTER //
// ./src/components/essence-material/essence-material.ts